import {
  IIconProps,
  IStyleFunctionOrObject,
  ITextFieldStyleProps,
  ITextFieldStyles,
} from 'office-ui-fabric-react';
import { theme } from '../../../../../theme';


export const textFieldIconProps: IIconProps = {
  iconName: 'calendar',
    styles: {
    root: {
      color: theme.colors.themePrimary,
    },
  },
};

export const textFieldStyles: IStyleFunctionOrObject<ITextFieldStyleProps, ITextFieldStyles> = {
  root: {
    width: '100%',
  },
};